import { IconX } from '@tabler/icons-react';
import { ButtonIconSquare } from 'src/components/buttons';
import { ModalStandard, ModalStandardContent, ModalStandardDescription, ModalStandardFooter, ModalStandardHeader, ModalStandardTitle } from 'src/components/standard.modal';

type Props = {
    show?: boolean,
    setShow?: (show: boolean) => void,
    invalidData: MissingData|null
};



type MonthType = {
    month: string;
    value: string;
    status: boolean;
    id?: number
}



type formType = {
    data: MonthType[]
}

type MissingData = {
    missing_categories: string[];
    missing_products: string[];
    missing_subattributes: string[];
    missing_subcategories: string[];
};


export function ModalValidationError(props: Props) {





    return (
        <ModalStandard open={props.show} onOpenChange={(show) => {

            props.setShow?.(show)
        }} >
            <ModalStandardContent className="bg-gray-100  flex flex-col"  >
                <ModalStandardHeader className=' grow' >
                    <ModalStandardTitle>{'NP Forcast Month'}</ModalStandardTitle>
                    <ModalStandardDescription >

                        <div className="h-full w-full overflow-auto max-h-[70vh]">
                            <table className="min-w-full bg-white border border-gray-200">
                                <thead>
                                    <tr>
                                        {Object.keys(props.invalidData||{}).map((key) => (
                                            <th key={key} className="px-4 py-2 border-b border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-600 uppercase">
                                                {key.replace(/_/g, ' ')}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {Object.values(props.invalidData||{}).map((value, index) => (
                                            <td key={index} className="px-4 py-2 border-b border-gray-200 text-sm text-gray-700 align-top">
                                                <ul className=' h-full'>
                                                    {value.map((item:any, itemIndex:number) => (
                                                        <div className=' whitespace-nowrap' key={itemIndex}>{item}</div>
                                                    ))}
                                                </ul>
                                            </td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className='min-h-2'></div>
                    </ModalStandardDescription>
                </ModalStandardHeader>
                <ModalStandardFooter>
                    <ButtonIconSquare
                        variant="white"
                        icon={<IconX />}
                        text="Close"
                        onClick={(e) => {
                            props.setShow?.(false);
                            e?.preventDefault();
                        }}
                    ></ButtonIconSquare>

                </ModalStandardFooter>
            </ModalStandardContent>
        </ModalStandard>
    );
}
